export const SURVEY_SOCKET_EVENTS = {
  // Outbound — emitted to join / leave rooms.
  SUBSCRIBE_TO_SURVEYS: 'subscribeToSurveys',
  UNSUBSCRIBE_FROM_SURVEYS: 'unsubscribeFromSurveys',
  JOIN_SURVEY_ROOM: 'joinSurveyRoom',
  LEAVE_SURVEY_ROOM: 'leaveSurveyRoom',
  JOIN_QUOTA_TAB_ROOM: 'joinQuotaTabRoom',
  LEAVE_QUOTA_TAB_ROOM: 'leaveQuotaTabRoom',
  JOIN_SUPPLIER_TAB_ROOM: 'joinSupplierTabRoom',
  LEAVE_SUPPLIER_TAB_ROOM: 'leaveSupplierTabRoom',
  JOIN_TC_TAB_ROOM: 'joinTcTabRoom',
  LEAVE_TC_TAB_ROOM: 'leaveTcTabRoom',

  // Inbound - listening channels
  SURVEY_COMPLETES: 'surveyCompletes',
  BUYER_IN_PROGRESS_CHANNEL: 'buyerProgressChannelV3',
  SURVEY_STATUS_CHANGE: 'surveyStatusChange',
  SURVEY_SCORE_CHANGE: 'surveyScoreChange',
  DASHBOARD_UPDATE: 'dashboard',
  SUPPLIER_SURVEY_CHANNEL: 'supplierChannel',
  TRAFFIC_CHANNEL_UPDATES: 'trafficChannelsTab',
} as const;
